import { render, staticRenderFns } from "./NotificationsToast.vue?vue&type=template&id=16dc659c&scoped=true&"
import script from "./NotificationsToast.vue?vue&type=script&lang=js&"
export * from "./NotificationsToast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dc659c",
  null
  
)

export default component.exports